import { useAvailablePaymentMethods, usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useSession } from 'src/app/shared/hooks/session';

import { useBanditTrackingProperties } from '../useBanditTrackingProperties';

import { useMemoizedProperties } from './useMemoizedProperties';

type Properties = Record<string, string | boolean | number | readonly string[] | readonly number[] | undefined>;

export function useTrackingProperties(): Properties {
	const [{ amount, isPublic, usingSavedPaymentMethod, paymentMethodSaveOptions }] = usePromotePageState();
	const {
		data: { amountChoices, currency, petition, promotionSettings, user },
	} = usePromotePageData();
	const { paymentMethods } = useAvailablePaymentMethods();

	const memoizedProperties = useMemoizedProperties();

	const banditTrackingProperties = useBanditTrackingProperties();

	const session = useSession();
	const sourceLocation = useQueryParamValue('source_location');
	const currentSource = useQueryParamValue('utm_source') || session.trackingData.current_source;

	const { categoryTags, geoReach, relevantLocationLocalizedName } = petition;

	return {
		cpm: promotionSettings.cpm,
		bonus_cpm: promotionSettings.bonusCpm ?? undefined,
		currency: currency.code,
		current_source: currentSource,
		custom_amount: !amountChoices.includes(amount),
		exchange_rate: currency.exchangeRate,
		local_amount: amount,
		own_petition: petition.user.id === user.id,
		petition_id: `petition_${petition.id}`,
		product_flow: 'promoted',
		promote_transaction: 'single',
		public: isPublic,
		save_payment_method: paymentMethodSaveOptions.shouldSavePaymentMethod,
		source_location: sourceLocation,
		use_saved_payment_method: usingSavedPaymentMethod,
		category_tags: categoryTags,
		geo_reach: geoReach ?? undefined,
		relevant_location_localized_name: relevantLocationLocalizedName ?? undefined,
		visible_payment_types: paymentMethods,
		...banditTrackingProperties,
		...memoizedProperties,
	};
}
